import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "22",
  height: "22",
  viewBox: "0 0 22 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#__clip0_5613_21998)" }, [
      _createElementVNode("path", {
        d: "M18.333 2.75H20.1663V8.25H18.333V4.58333H14.6663V2.75H18.333ZM3.66634 2.75H7.33301V4.58333H3.66634V8.25H1.83301V2.75H3.66634ZM18.333 17.4167V13.75H20.1663V19.25H14.6663V17.4167H18.333ZM3.66634 17.4167H7.33301V19.25H1.83301V13.75H3.66634V17.4167Z",
        fill: "currentColor"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "__clip0_5613_21998" }, [
        _createElementVNode("rect", {
          width: "22",
          height: "22",
          fill: "currentColor"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }